module.exports = __webpack_public_path__ + "static/img/iconfont.bedc707.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/iconfont.svg?t=1602470866315
// module id = OO1I
// module chunks = 1